import { ApolloError } from "@apollo/client";
import { useCallback, useMemo } from "react";
import { transformApolloError } from "@/lib/error/error-utils";
import { AuthStatus, useAuthStore } from "@/lib/store/auth-enhanced";

// For now, we'll use the auth store data since there's no specific profile query
// This can be extended when we have a dedicated profile GraphQL query
export const useProfileQuery = () => {
  const { user, isAuthenticated, status } = useAuthStore();
  const isLoading = status === AuthStatus.INITIALIZING;

  const error = useMemo(() => {
    if (!isAuthenticated && !isLoading) {
      return transformApolloError(new Error("Not authenticated") as ApolloError);
    }
    return null;
  }, [isAuthenticated, isLoading]);

  const retry = useCallback(() => {
    // Since we're using auth store, retry would be handled by auth refresh
    window.location.reload();
  }, []);

  return {
    data: user,
    loading: isLoading,
    error,
    retry,
    refetch: retry,
  };
};
